import { cva } from 'class-variance-authority'

export const toastVariants = cva(
  'text-sm shadow-lg font-sans-semi-bold space-x-4 px-5 py-2.5 md:py-5',
  {
    variants: {
      variant: {
        success: 'text-white bg-green',
        danger: 'text-white bg-red',
        warning: 'text-white bg-orange',
        info: [
          'text-black bg-white',
          'prose-a:text-primary prose-a:underline prose-p:inline',
        ],
      },
    },
  }
)
